import { createContext, useContext, useState, type ReactNode } from 'react';
import { createElement } from 'react';
import type { Dictionary, Lang } from './types';
import { en } from './en';
import { vi } from './vi';
import { ja } from './ja';
import { ko } from './ko';

const DICTS: Record<Lang, Dictionary> = { en, vi, ja, ko };

interface I18nContextValue {
  lang: Lang;
  setLang: (l: Lang) => void;
  dict: Dictionary;
}

export const I18nContext = createContext<I18nContextValue | null>(null);

export function I18nProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Lang>('vi');
  const dict = DICTS[lang];
  return createElement(I18nContext.Provider, { value: { lang, setLang, dict } }, children);
}

export function useTranslation() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useTranslation must be used inside I18nProvider');
  return ctx;
}
